import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar } from 'react-bootstrap';
import config from './config.json';

const Step1 = ({ nextStep }) => {
  const [type_bien, setTypeBien] = useState('');
  const currentStep = 1;

  useEffect(() => {
    const storedValue = localStorage.getItem('type_bien');
    if (storedValue) {
      setTypeBien(storedValue);
    }
  }, []);

  const handleChange = (event) => {
    const { value } = event.target;
    setTypeBien(value);
    localStorage.setItem('type_bien', value);
    nextStep();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    nextStep();
  };

  return (
    <Container>
      <ProgressBar now={(currentStep / config.totalSteps) * 100} style={{ backgroundColor: "#bad7f1" }}>
        <ProgressBar now={(currentStep / config.totalSteps) * 100} style={{ backgroundColor: "#0be288" }} />
      </ProgressBar>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col>
              <h2>{config.step1.step}</h2>
              <h3>{config.step1.title}</h3>
          </Col>
        </Row>
        <Row className='justify-content-center'>
          {[
            { label: 'Résidentiel', value: 'residentiel', image: `${config.linkImage}${config.step1.image1}` },
            { label: 'Tertiaire', value: 'tertiaire', image: `${config.linkImage}${config.step1.image2}`},
            { label: 'Industriel', value: 'industriel', image: `${config.linkImage}${config.step1.image3}`},
          ].map(({ label, value, image }, index) => (
            <Col key={index} className={`card ${type_bien === value ? 'selected' : ''}`}>
                  <label className="building-type-label">
                    <input
                      type="radio"
                      value={value}
                      checked={type_bien === value}
                      onChange={handleChange}
                      className="d-none"
                    />
                    <div className={`icon-container ${type_bien === value ? 'selected' : ''}`}>
                      <img src={image} className="size-img" alt={label} />
                      <p>{label}</p>
                    </div>
                  </label>
            </Col>
          ))}
        </Row>
        <Row className="mt-3">
          <Col>
            <Button type="submit" disabled={type_bien === ""} variant="primary">
              Suivant
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default Step1;
